// extracted by mini-css-extract-plugin
export var textInput = "_kd-0";